const OBJ_BLANK = "@BLANK"

// ----- porin object ------
const OBJ_BOM_RED = "@PORIN"
const OBJ_BOM_GREEN = "@POPORIN"
const OBJ_BOM_BLUE = "@MARIN"
const OBJ_BOM_YELLOW = "@DROPS"

// ----- monster object -----
const OBJ_MOB_ELVIRA = "@ELVIRA"
const OBJ_MOB_SEOHYUN = "@SEOHYUN"
const OBJ_MOB_RUDO = "@RUDO"
const OBJ_MOB_LOLA = "@LOLA"
const OBJ_MOB_ZILANT = "@ZILANT"
const OBJ_MOB_GARM = "@GARM"
const OBJ_MOB_NIGHTMARE = "@NIGHTMARE"
const OBJ_MOB_GRYPHON = "@GRYPHON"

// ----- stage object -----
const OBJ_TREASURE = "@TREASURE"
const OBJ_IMMORTAL_CLYSTAL = "@IMMORTAL1"
const OBJ_IMMORTAL_POLE = "@IMMORTAL2"
const OBJ_IMMORTAL_BED = "@IMMORTAL3"
const OBJ_IMMORTAL_TABLE = "@IMMORTAL4"
const OBJ_IMMORTAL_GATE = "@IMMORTAL5"
const OBJ_IMMORTAL_TOMB = "@IMMORTAL6"

const isBlank = (object) => (object === OBJ_BLANK);
const isPorinObject = (object) => (
    object === OBJ_BOM_RED ||
    object === OBJ_BOM_GREEN ||
    object === OBJ_BOM_BLUE ||
    object === OBJ_BOM_YELLOW);
const isMonsterObject = (object) => (
    object === OBJ_MOB_ELVIRA ||
    object === OBJ_MOB_LOLA ||
    object === OBJ_MOB_RUDO ||
    object === OBJ_MOB_SEOHYUN ||
    object === OBJ_MOB_ZILANT ||
    object === OBJ_MOB_GARM ||
    object === OBJ_MOB_NIGHTMARE ||
    object === OBJ_MOB_GRYPHON);
const isTreasure = (object) => (object === OBJ_TREASURE);
const isImmortal = (object) => (
    object === OBJ_IMMORTAL_CLYSTAL ||
    object === OBJ_IMMORTAL_POLE ||
    object === OBJ_IMMORTAL_BED ||
    object === OBJ_IMMORTAL_TABLE ||
    object === OBJ_IMMORTAL_GATE ||
    object === OBJ_IMMORTAL_TOMB);
export default {
    OBJ_BLANK,
    OBJ_BOM_RED,
    OBJ_BOM_GREEN,
    OBJ_BOM_BLUE,
    OBJ_BOM_YELLOW,
    OBJ_MOB_ELVIRA,
    OBJ_MOB_SEOHYUN,
    OBJ_MOB_RUDO,
    OBJ_MOB_LOLA,
    OBJ_MOB_ZILANT,
    OBJ_MOB_GARM,
    OBJ_MOB_NIGHTMARE,
    OBJ_MOB_GRYPHON,
    OBJ_TREASURE,
    OBJ_IMMORTAL_CLYSTAL,
    OBJ_IMMORTAL_POLE,
    OBJ_IMMORTAL_BED,
    OBJ_IMMORTAL_TABLE,
    OBJ_IMMORTAL_GATE,
    OBJ_IMMORTAL_TOMB,
    isBlank,
    isPorinObject,
    isMonsterObject,
    isTreasure,
    isImmortal
}